// src/hooks/useSchool.js
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

/**
 * Returns the schoolId from the URL (/[:schoolId]/...) when present.
 * Falls back to the signed-in user's schoolId from Firestore if not in the URL.
 */
export function useSchool() {
  const { schoolId: urlSchoolId } = useParams();
  const [effectiveSchoolId, setEffectiveSchoolId] = useState(urlSchoolId || "");

  // 1) React to URL changes immediately
  useEffect(() => {
    if (urlSchoolId) setEffectiveSchoolId(urlSchoolId);
  }, [urlSchoolId]);

  // 2) If no URL school, resolve from the signed-in user (and react to auth changes)
  useEffect(() => {
    if (urlSchoolId) return; // URL takes precedence

    let isMounted = true;
    const stop = onAuthStateChanged(auth, async (user) => {
      if (!user || !isMounted) return;
      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        const sid = snap.exists() ? snap.data().schoolId : "";
        if (isMounted && sid) setEffectiveSchoolId(sid);
      } catch (e) {
        console.error("Failed to load user schoolId:", e);
      }
    });

    return () => {
      isMounted = false;
      stop();
    };
  }, [urlSchoolId]);

  return effectiveSchoolId;
}